//                                                    
import { repo } from '@bi/sync';
export const CubesRepository = repo.koob.CubesRepository;
export const DimensionsRepository = repo.koob.DimensionsRepository;
